import React from 'react';
import ReactExport from 'react-data-export';
import { Order } from '../interfaces';
import { Button } from '@material-ui/core';
import Icon from '@mdi/react';
import { mdiTableArrowUp } from '@mdi/js';
import jMoment from 'moment-jalaali';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

interface Props {
  loading: boolean;
  data: Order[];
  handleRequest: any;
  filtersValues: any;
}


const ExelExport = ({ loading, data, handleRequest, filtersValues }: Props) => {
  const handleCreateExel = () => {
    handleRequest({ ...filtersValues, page: undefined, size: 2000 });
  };

  const flattData = (data: any) => {
    const newData = data.map((item: any) => {
      return {
        ...item,
        deliveryDateFa: item.deliveryDate &&
          jMoment(item.deliveryDate, 'YYYY/M/D')
            .locale('fa')
            .format('jYY/jMM/jDD'),
        deliveryDate: item.deliveryDate,
        customerMobileNumber: item.customerMobileNumber + '',
        packages: undefined,
        childOrders: undefined,
      };
    });
    return newData;
  };

  if (data.length > 0) {
    return (
      <ExcelFile element={<Button
        style={{ marginLeft: '5px' }}
        variant="contained"
        color="secondary"
      >
        دانلود فایل EXCEL
      </Button>}>
        <ExcelSheet data={flattData(data)} name="orders">
          {data && Object.entries(flattData(data)[0])?.map(el => {
            return (
              <ExcelColumn label={el[0]} value={el[0]} />
            );
          })}
        </ExcelSheet>
      </ExcelFile>
    );
  } else {
    return (
      <Button
        style={{ marginLeft: '5px' }}
        variant="contained"
        color="primary"
        startIcon={<Icon path={mdiTableArrowUp} size={1} />}
        onClick={handleCreateExel}
        disabled={loading}
      >
        ایجاد فایل EXCEL
      </Button>

    );
  }
};

export default ExelExport;
